import {Component, inject} from '@angular/core';
import {CharityManagementComponent} from "../charity-management.component";
import {
  ColComponent,
  ContainerComponent,
  ListGroupDirective,
  ListGroupItemDirective,
  RowComponent
} from "@coreui/angular";
import {GameService} from "../../../services/game.service";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {CharityService} from "../../../services/charity.service";
import {CharityManagementScreenState} from "../../../enum/CharityManagementScreenState";
import {
  MovePlayersPledgesBetweenCharitiesComponent
} from "../../../components/charity/move-players-pledges-between-charities/move-players-pledges-between-charities.component";

@Component({
  selector: 'app-game-admin-charity-management',
  standalone: true,
  imports: [CharityManagementComponent, ContainerComponent, ColComponent, HasPermissionDirective, MatButton, MatIcon, RowComponent, ListGroupDirective, ListGroupItemDirective, MovePlayersPledgesBetweenCharitiesComponent],
  templateUrl: './game-admin-charity-management.component.html',
  styleUrl: './game-admin-charity-management.component.css'
})
export class GameAdminCharityManagementComponent {
  private gameService: GameService = inject(GameService);
  private charityService: CharityService = inject(CharityService);

  protected activeGame =  this.gameService.activeGame();
  protected currentScreenState: CharityManagementScreenState = CharityManagementScreenState.SortAndView;
  protected readonly PermissionTypes = PermissionTypes;
  protected readonly charityManagementScreenState = CharityManagementScreenState;

  addNewCharities() {
    this.charityService.openAddCharityDialog(this.activeGame?.Id!);
  }

}
